import { Checkbox } from '@blueprintjs/core'
import * as React from 'react'
import { CategoryRowStyle } from './styles'
import { CategoryMultiselectCategory } from './types'

export interface CategorySearchRowProps {
  category: CategoryMultiselectCategory
  checked: boolean
  query: string
  matchIndex: number
  onCheck: (category: CategoryMultiselectCategory) => void
}

export const CategorySearchRow: React.FC<CategorySearchRowProps> = props => {
  const onCheck = (e: React.FormEvent) => {
    e.stopPropagation()
    props.onCheck(props.category)
  }

  const { pathCache } = props.category
  const replaceRange = { start: props.matchIndex, end: props.matchIndex + props.query.length }
  const firstHalf = pathCache.substring(0, replaceRange.start)
  const middle = pathCache.substring(replaceRange.start, replaceRange.end)
  const lastHalf = pathCache.substring(replaceRange.end)
  return (
    <label style={CategoryRowStyle}>
      <Checkbox
        checked={props.checked}
        onChange={onCheck}
        style={{ margin: 0 }}
        tabIndex={-1}
        onClick={e => e.stopPropagation()} // Prevent double toggle
      />
      <span style={{ cursor: 'pointer', userSelect: 'none', marginLeft: 4 }} onClick={onCheck}>
        {firstHalf}
        <b>{middle}</b>
        {lastHalf}
      </span>
    </label>
  )
}
